import React from 'react';
import { User, Settings, ChevronUp, History, ChevronRight, LogOut } from 'lucide-react';

const AccountStatusCard = ({
  profile,
  isOpen,
  onToggle,
  onEditProfile,
  onOpenPaymentHistory,
  onLogout,
}) => {

  return (
    <div
      className={`bg-white rounded-3xl p-4 border border-gray-100 shadow-none border border-gray-200 transition-all duration-300 ${
        isOpen ? 'ring-1 ring-gray-200' : ''
      }`}
    >

      {/* ================= Header ================= */}
      <div
        onClick={onToggle}
        className="flex items-center gap-3 cursor-pointer active:opacity-60 transition-opacity"
      >
        <div className="w-9 h-9 bg-gray-100 text-gray-900 rounded-xl flex items-center justify-center border border-gray-200/60">
          <User size={20} />
        </div>

        <div className="flex flex-col min-w-0">
          <p className="text-base font-black text-gray-800 truncate">
            {profile.name || 'ゲスト'}
          </p>
          {profile.email && (
            <p className="text-xs text-gray-500 truncate">
              {profile.email}
            </p>
          )}
        </div>
      </div>

      {/* ================= Content ================= */}
      {isOpen && (
        <div className="pt-5 mt-4 border-t border-gray-100 space-y-4">

          {/* 購入履歴 */}
<button
  onClick={onOpenPaymentHistory}
  className="w-full bg-gray-50 border border-gray-200
             hover:bg-gray-100 transition-all
             font-bold py-4 rounded-3xl
             flex items-center justify-between px-4"
>
  <div className="flex items-center gap-3">
    <div className="w-5 flex justify-center">
      <History size={18} className="text-gray-900" />
    </div>
    <span className="text-gray-900">購入履歴・支払い管理</span>
  </div>
  <ChevronRight size={18} className="text-gray-900" />
</button>

<button
  onClick={onEditProfile}
  className="w-full py-4 px-4 rounded-3xl font-black text-base
             flex items-center justify-start
             bg-gray-700 text-white
             hover:bg-black active:scale-95 transition-all shadow-md"
>
  <div className="flex items-center gap-3">
    <div className="w-5 flex justify-center">
      <Settings size={18} />
    </div>
    <span>プロフィールを編集する</span>
  </div>
</button>

          {/* ログアウト（静かに） */}
          <button
            type="button"
            onClick={onLogout}
            className="w-full mt-2 flex items-center justify-center gap-2
                       text-xs font-black text-gray-500
                       hover:text-gray-700 transition-colors"
          >
            <LogOut size={14} />
            ログアウト
          </button>

          {/* 閉じる */}
          <button
            onClick={onToggle}
            className="w-full mt-4 py-3 rounded-3xl
                       text-gray-600 font-black
                       
                       hover:bg-gray-100 transition-all
                       flex items-center justify-center gap-2"
          >
            <ChevronUp size={20} className="text-gray-900" />
            閉じる
          </button>

        </div>
      )}
    </div>
  );
};

export default AccountStatusCard;